import { IconExpand } from '../../icon';

export default function SortArrows() {
	return (
		<div className="flex shrink-0 flex-col gap-[2px]" aria-hidden="true">
			<IconExpand width={11} height={6} className="rotate-180 text-text-secondary" />
			<IconExpand width={11} height={6} className="text-text-secondary" />
		</div>
	);
}
